import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import { parseJwt } from '../utils/parseJwt';
import { temAcessoAndon } from '../utils/andon';
import { aplicarParametroMock } from '../pages/Andon/andonDev';

// Guarda de interface do Andon: admin, ou exxer com usuarios.andon = 'tv'/'gestao'.
// Quem decide de verdade é o backend (GET /api/andon/painel devolve 403).
const AndonRoute = () => {
  const { usuario } = useAuth();
  const { search } = useLocation();
  const token = sessionStorage.getItem('token') || localStorage.getItem('token');
  if (!token) return <Navigate to="/login" />;

  aplicarParametroMock(search); // só em desenvolvimento (npm start); em produção não existe
  const usuarioAtual = usuario || parseJwt(token);
  if (!temAcessoAndon(usuarioAtual)) return <Navigate to="/home" />;
  return <Outlet />;
};

export default AndonRoute;
